import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { PageMembershipMatchingAttributesList } from '../partials/PageMembershipMatchingAttributesList';

type PageMembershipMatchingAttributesDefaultProps = {
  matchingAttributes: string[];
};

export function PageMembershipMatchingAttributesDefault({
  matchingAttributes,
}: PageMembershipMatchingAttributesDefaultProps) {
  return <PageMembershipMatchingAttributesList matchingAttributes={matchingAttributes} />;
}

export const PageMembershipMatchingAttributesDefaultView = asFetchableView(PageMembershipMatchingAttributesDefault);
export type PageMembershipMatchingAttributesDefaultView = ComponentProps<
  typeof PageMembershipMatchingAttributesDefaultView
>;
